import axios from "axios"
import Proveedor from './models/Proveedor';

export default class Utils {

    static async getProfileData() {
        try
        {
            const response = await axios.get("/.auth/me");
            console.log("log: ", response);

            // Buscar el status
            const status = response?.data?.status ?? response?.status;

            // Obtener el contenido (ya sea data.data o data)
            const payload = response?.data ?? response;

            if (status === 500) {
                alert("error de sistema");
            }

            if (status !== undefined && status !== 200) {
                return null;
            }

            return payload;
        }
        catch (error) {
            console.log("error en getProfileData: ", error);
            return null;
        }
    }

    static async getUserInfo() {
        let response;
        try {
            response = await axios.get("/api/Usuario");
            return response;
        } catch (error) {
            console.log("error en getUserInfo: ", error);
            return error;
        }
    }

    static async getTermYCond() {
        try {
            const response = await axios.get("/api/TermYCond");
            return response.status;
        } catch (error) {
            if (error.response) {
                return error.response.status; 
            } else if (error.request) {
                return 0;
            } 
        }

    }

    static async aceptarTermYCond() {
        let response;
        try {
            response = await axios.get("/api/TermYCond/aceptar");
            if (response.status === 200) {
                return response;
            }
        } catch (error) {
            console.log("error: ", error);
        }
    }

    static async documentoInfo() {
        let response;
        try {
            response = await axios.get("/api/Documento/info");
            if (response.status === 200) {
                return response;
            }
        } catch (error) {
            console.log("error: ", error);
        }
    }

    static async setDocumento(formData, version) {
        let response;
        try {
            response = await axios.post("/api/Documento/?version=" +version, formData,
                { headers: { 'Content-Type': 'multipart/form-data;' } });
            if (response.status === 200) {
                return response;
            }
        } catch (error) {
            console.log("error: ", error);
            return response;
        }
    }

    static async getProveedor() {
        let prov = Proveedor;
        let response;
        try {
            response = await axios.get("/api/Proveedores");
            if (response.status === 200) {
                const data = response.data;
                prov.Id = data.id;
                prov.RazonSocial = data.razonSocial;
                prov.FactoresQueSuman = data.factoresQueSuman;
                prov.SubtotalP = data.subtotalP;
                prov.factoresQueRestan = data.factoresQueRestan;
                prov.Subtotal = data.subtotal;
                prov.Total = data.total;
                prov.UltimaActualizacion = data.ultimaActualizacion;
            }
        } catch (error) {
            if (error.response.status == 400) prov = -1;
            if (error.response.status == 404) prov = 0;
            console.log("error: ", error);
        }
        return prov;
    }

    static async getProveedorInfo(cuit) {
        let prov = Proveedor;
        let response;
        try {
            response = await axios.get("api/Proveedores/"+cuit);
            if (response.status === 200) {
                const data = response.data;
                prov.Id = data.id;
                prov.RazonSocial = data.razonSocial;
                prov.FactoresQueSuman = data.factoresQueSuman;
                prov.SubtotalP = data.subtotalP;
                prov.factoresQueRestan = data.factoresQueRestan;
                prov.Subtotal = data.subtotal;
                prov.Total = data.total;
                prov.UltimaActualizacion = data.ultimaActualizacion;
            }
        } catch (error) {
            prov.Id = 0;
            console.log("error: ", error);
        }
        return prov;
    }

    static async setProveedorInfo(json) {
        let response;
        try {
            response = await axios.post("api/Proveedores/", json,
                { headers: { 'Content-Type': 'application/json' } });
            if (response.status === 200) {
                alert("Informaci�n de proveedores actualizada correctamente.")
                return true;
            }
        } catch (error) {
            alert("Error: no se pudo actualizar la informaci�n de proveedores.")
            console.log("error: ", error);
        }
        return false;
    }

    static async getProveedores() {
        let response;
        try {
            response = await axios.get("api/Proveedores/lista");
            if (response.status === 200) {
                return response.data;
            }
        } catch (error) {
            console.log("error: ", error);
        }
        return null;
    }

    static async logOut() {
        fetch("/.auth/end-session");
        window.location.href = "https://portal-extranet.test.ypf.com/";
    }

    static async getProveedorTest() {
        let prov = Proveedor;
        let response;
        try {
            response = await axios.get("https://scoredeproveedores-back-dev.test.ypf.com/api/Proveedores/test");
            if (response.status === 200) {
                const data = response.data;
                prov.Id = data.id;
                prov.RazonSocial = data.razonSocial;
                prov.FactoresQueSuman = data.factoresQueSuman;
                prov.SubtotalP = data.subtotalP;
                prov.factoresQueRestan = data.factoresQueRestan;
                prov.Subtotal = data.subtotal;
                prov.Total = data.total;
                prov.UltimaActualizacion = data.ultimaActualizacion;
            }
        } catch (error) {
            prov.Id = 0;
            console.log("error: ", error);
        }
        return prov;
    }

    static async getArchivo() {
        let response;
        try {
            response = await axios.get("/api/TermYCond/s");
            if (response.status === 200) {
                return response;
            }
        } catch (error) {
            console.log("error: ", error);
            alert("Ocurrio un error, inente nuevamente mas tarde.")
        }
    }

    static async getFactoresSuma() {
        let factores = [];
        let response;
        try {
            response = await axios.get("api/Semaforo");
            if (response.status === 200) {
                if (response.data.length>0) 
                    factores = response.data;
            }
        } catch (error) {
            console.log("error: ", error);
        }
        return factores;
    }

    static async setFactoresSuma(json) {
        let response;
        try {
            response = await axios.post("api/Semaforo", json,
                {headers: {'Content-Type': 'application/json'} }
            );
            if (response.status === 200) {
                alert("Factores actualizados")
            }
        } catch (error) {
            console.log("error: ", error);
        }
        return true;
    }

    static async getFactoresResta() {
        let factores = [];
        let response;
        try {
            response = await axios.get("api/Semaforo/r");
            if (response.status === 200) {
                if (response.data.length > 0)
                    factores = response.data;
            }
        } catch (error) {
            console.log("error: ", error);
        }
        return factores;
    }

    static async setFactoresResta(json) {
        let response;
        try {
            response = await axios.post("api/Semaforo/r", json,
                { headers: { 'Content-Type': 'application/json' } }
            );
        } catch (error) {
            console.log("error: ", error);
        }
        return true;
    }

    static async getNiveles() {
        let niveles = [];
        let response;
        try {
            response = await axios.get("api/Nivel");
            if (response.status === 200) {
                if (response.data.length > 0)
                    niveles = response.data;
            }
        } catch (error) {
            console.log("error: ", error);
        }
        return niveles;
    }

    static async setNiveles(json) {
        let response;
        try {
            response = await axios.post("api/Nivel", json,
                { headers: { 'Content-Type': 'application/json' } }
            );
            if (response.status === 200) {
                alert("Niveles actualizados")
            }
        } catch (error) {
            console.log("error: ", error);
        }
        return true;
    }

    static async getBeneficios() {
        let beneficios = [];
        let response;
        try {
            response = await axios.get("api/Beneficio");
            if (response.status === 200) {
                if (response.data.length > 0)
                    beneficios = response.data;
            }
        } catch (error) {
            console.log("error: ", error);
        }
        return beneficios;
    }

    static async setBeneficios(json) {
        let response;
        try {
            response = await axios.post("api/Beneficio", json,
                { headers: {'Content-Type': 'application/json'} }
            );
            if (response.status === 200) {
                alert("Beneficios actualizados")
            }
        } catch (error) {
            console.log("error: ", error);
        }
        return true;
    }

}